

import React, { lazy, Suspense } from 'react';

// Lazy load components
const Dashboard = lazy(() => import('../../components/DashboardModule/Dashboard'));
const Profile = lazy(() => import('../../components/AuthModule/profile/Profile'));
const UsersList = lazy(() => import('../../components/UserModule/UsersList'));
const ProjectList = lazy(() => import('../../components/ProjectModule/ProjectList'));
const CreateProject = lazy(() => import('../../components/ProjectModule/CreateProject/CreateProject'));
const ClientList = lazy(() => import('../../components/CustomersModule/CustomersList'));
const CreateCustomer = lazy(() => import('../../components/CustomersModule/CreateCustomer'));
const ProductList = lazy(() => import('../../components/ProductModule/ProductList'));
const CreateProduct = lazy(() => import('../../components/ProductModule/CreateProduct'));

const CreateUserScreen =lazy(()=> import('../../components/UserModule/CreateUser'))
const Settingscreen    =lazy (()=>import('../../components/SettingsModule/SettingsBase'))
const AuthenticationLog =lazy (()=>import( '../../components/SettingsModule/Settings/AuthenticationLog'));
const ProdductPrice =lazy (()=>import( '../../components/SettingsModule/Settings/ProductPrice'));
const ConfigurationPresets =lazy (()=>import( '../../components/SettingsModule/Settings/ConfigurationPresets'));
const AddConfigPresets =lazy (()=>import( '../../components/SettingsModule/Settings/ConfigurationPresets/AddConfigPresets'));
const Loader =lazy (()=>import( '../../genriccomponents/loaders/RedLoader'));
const ProjectFiles =lazy (()=>import( '../../components/ProjectModule/ProjectView/ProjectFiles'));
const ProjectTakeOffStructure =lazy (()=>import( '../../components/ProjectModule/ProjectView/ProjectTakeoffStructureView'));
const ProjectStructure =lazy (()=>import( '../../components/ProjectModule/ProjectView/ProjectStructure'));
const ProjectSettings =lazy (()=>import( '../../components/ProjectModule/ProjectView/ProjectSettings'));
const ProjectSubmitals =lazy (()=>import( '../../components/ProjectModule/ProjectView/ProjectSubmitals'));
const BasicDetilsForm  = lazy (()=>import('../../components/ProjectModule/CreateProject/BasicDetailsForm'));
const UploadPdfFile  = lazy (()=>import('../../components/ProjectModule/CreateProject/UploadPdfFile'));
const DefaultConfig  = lazy (()=>import('../../components/ProjectModule/CreateProject/DefaultConfig'));
const ProjectSummary  = lazy (()=>import('../../components/ProjectModule/CreateProject/ProjectSummary/ProjectSummary'));
const Projectbase     = lazy (()=>import('../../components/ProjectModule/ProjectView/ViewBaseProject'));
const ProjectOverview     = lazy (()=>import('../../components/ProjectModule/ProjectView/ProjectOverview'))
const PdfViewer  = lazy (()=>import('../../components/pdfModule/pdfViewer/Viewer'));
const HelperContent  = lazy (()=>import('../../components/HelpModule/HelperContent'));

// Fallback component for Suspense
const Loading = () => <div><Loader /></div>; // Assuming RedLoader is an existing loader component

// Wrap lazy-loaded components with Suspense
const ProtectedDashboard = () => (
  <Suspense fallback={<Loading />}>
    <Dashboard />
  </Suspense>
);



const ProtectedProfile = () => (
  <Suspense fallback={<Loading />}>
    <Profile />
  </Suspense>
);

const ProtectedUserList = () => (
  <Suspense fallback={<Loading />}>
    <UsersList />
  </Suspense>
);


const ProtectedPrjectList = () => (
  <Suspense fallback={<Loading />}>
    <ProjectList />
  </Suspense>
);



const CreateUser = () => (
  <Suspense fallback={<Loading />}>
    <CreateUserScreen />
  </Suspense>
);

const ProductedSettings = () => (
  <Suspense fallback={<Loading />}>
    <Settingscreen />
  </Suspense>
);

const ProductAuthenticationLog = () => (
  <Suspense fallback={<Loading />}>
    <AuthenticationLog />
  </Suspense>
);

const ProductProdductPrice = () => (
  <Suspense fallback={<Loading />}>
    <ProdductPrice />
  </Suspense>
);
const ProductConfigurationPresets = () => (
  <Suspense fallback={<Loading />}>
    <ConfigurationPresets />
  </Suspense>
);
const AddNewConfigurationPresets = () => (
  <Suspense fallback={<Loading />}>
    <AddConfigPresets />
  </Suspense>
);

const ProductedClientList = () => (
  <Suspense fallback={<Loading />}>
    <ClientList />
  </Suspense>
);

const ProductedProductList = () => (
  <Suspense fallback={<Loading />}>
    <ProductList />
  </Suspense>
);


const ProductedCreateCustomer = () => (
  <Suspense fallback={<Loading />}>
    <CreateCustomer />
  </Suspense>
);

const ProductedCreateProduct = () => (
  <Suspense fallback={<Loading />}>
    <CreateProduct />
  </Suspense>
);

const ProductedCreateProject = () => (
  <Suspense fallback={<Loading />}>
    <CreateProject />
  </Suspense>
);

const ProductedBasicDeatils = () => (
  <Suspense fallback={<Loading />}>
    <BasicDetilsForm />
  </Suspense>
);

const ProductedUploadPdfFile = () => (
  <Suspense fallback={<Loading />}>
    <UploadPdfFile />
  </Suspense>
);

const ProductedDefaultConfigs = () => (
  <Suspense fallback={<Loading />}>
    <DefaultConfig />
  </Suspense>
);

const ProductedProjectSummary = () => (
  <Suspense fallback={<Loading />}>
    <ProjectSummary />
  </Suspense>
);

const ProductdPdfviewer = () => (
  <Suspense fallback={<Loading />}>
    <PdfViewer />
  </Suspense>
);
const UserHelperContent = () => (
  <Suspense fallback={<Loading />}>
    <HelperContent />
  </Suspense>
);

const ProductdProjectOverview = () => (
  <Suspense fallback={<Loading />}>
    <ProjectOverview />
  </Suspense>
);

const ProductdProjectBase = () => (
  <Suspense fallback={<Loading />}>
    <Projectbase />
  </Suspense>
);
const ProductdProjectFiles = () => (
  <Suspense fallback={<Loading />}>
    <ProjectFiles />
  </Suspense>
);
const  ProjectTakeOffStructureView = () => (
  <Suspense fallback={<Loading />}>
    <ProjectTakeOffStructure/>
  </Suspense>
);

const ProductdProjectStructure = () => (
  <Suspense fallback={<Loading />}>
    <ProjectStructure />
  </Suspense>
);



const ProductdProjectSubmittals = () => (
  <Suspense fallback={<Loading />}>
    <ProjectSubmitals />
  </Suspense>
);

const ProductdProjectSettings = () => (
  <Suspense fallback={<Loading />}>
    <ProjectSettings />
  </Suspense>
);






export {
  ProductProdductPrice,
  ProductConfigurationPresets,
  AddNewConfigurationPresets,
  ProductedProjectSummary,
  ProductedDefaultConfigs,
  ProductedUploadPdfFile,
  ProductedSettings,
  ProductAuthenticationLog,
  ProtectedDashboard,
  ProtectedProfile,
  ProtectedUserList,
  ProtectedPrjectList,
  CreateUser,
  ProductedClientList,
  ProductedProductList,
  ProductedCreateCustomer,
  ProductedCreateProduct,
  ProductedCreateProject,
ProductedBasicDeatils,
  ProductdPdfviewer,
  UserHelperContent,
  ProductdProjectBase,
  ProductdProjectOverview,
  ProductdProjectFiles,
  ProjectTakeOffStructureView,
  ProductdProjectStructure,
  ProductdProjectSubmittals,
  ProductdProjectSettings
};